import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';

export interface LanguageResponse {
	Id: number;
	LangCode: string;
	Name: string;
	IsHide: boolean;
}

export interface UpdateLanguageRequest {
	Id?: number;
	LangCode: string;
	Name: string;
	IsHide: boolean;
}

export default class LanguageService {
	webApiService: WebApiService;
	GetLanguagesEvent = new Events<WsResponseModelT<Array<String | LanguageResponse> | LanguageResponse>>();
	UpdateLanguageEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteLanguageEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('LanguageService', 'GetLanguages', (res: WsResponseModelT<Array<String | LanguageResponse> | LanguageResponse>) => {
			self.GetLanguagesEvent.trigger(res);
		});
		webApiService.on('LanguageService', 'UpdateLanguage', (res: WsResponseModelT<Boolean>) => {
			self.UpdateLanguageEvent.trigger(res);
		});
		webApiService.on('LanguageService', 'DeleteLanguage', (res: WsResponseModelT<Boolean>) => {
			self.DeleteLanguageEvent.trigger(res);
		});
	}
	GetLanguages() { 	
        this.webApiService.send('LanguageService', 'GetLanguages' );
    }
	UpdateLanguage(request: UpdateLanguageRequest = null) {
        this.webApiService.send('LanguageService', 'UpdateLanguage', request);
    }
	DeleteLanguage(id: number = 0) {
        this.webApiService.send('LanguageService', 'DeleteLanguage', id);
    }
	 // async methods
	async getLanguagesAsync(): Promise<Array<String | LanguageResponse> | LanguageResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetLanguages.bind(this), this.GetLanguagesEvent)();
	}
	async updateLanguageAsync(request: UpdateLanguageRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateLanguage.bind(this), this.UpdateLanguageEvent)(request);
	}
	async deleteLanguageAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteLanguage.bind(this), this.DeleteLanguageEvent)(id);
	}
}
